"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _BindingContext = require("./BindingContext");

function useFormValues(fields) {
  const ctx = (0, _BindingContext.useBindingContext)();
  if (!ctx) return;
  return Array.isArray(fields) ? fields.map(f => ctx.getValue(f)) : ctx.getValue(fields);
}

var _default = useFormValues;
exports.default = _default;